import { all } from 'redux-saga/effects';
import AppSaga from './containers/app-container/saga/AppSaga';
import AreaSaga from './containers/area-container/saga/AreaSaga';
import AuthSaga from './containers/auth-container/saga/AuthSaga';
import CatalogueSaga from './containers/catalogue-container/saga/CatalogueSaga';
import CitySaga from './containers/city-container/saga/CitySaga';
import CommissionSaga from './containers/commission-container/saga/CommissionSaga';
import CompanySaga from './containers/company-container/saga/CompanySaga';
import FileSaga from './containers/files-container/saga/FileSaga';
import CustomerSaga from './containers/customer-container/saga/CustomerSaga';
import PermissionsMasterSaga from './containers/permissions-container/saga/PermissionsMasterSaga';
import RolePermissionsSaga from './containers/permissions-container/saga/RolePermissionsSaga';
import ProductSaga from './containers/product-container/saga/ProductSaga';
import RemarkSaga from './containers/remarks-container/saga/RemarkSaga';
import StateSaga from './containers/state-container/saga/StateSaga';
import UserSaga from './containers/user-container/saga/UserSaga';
import CaseSaga from './containers/case-container/saga/CaseSaga';
import ExcelSaga from './containers/excel-container/saga/ExcelSaga';
import CrossSaleSaga from './containers/cross-sale-container/saga/CrossSaleSaga';
import MastersSaga from './containers/masters-container/saga/MastersSaga';
import TargetSaga from './containers/target-container/saga/TargetSaga';
import WalletSaga from './containers/wallet-container/saga/WalletSaga';
import InsuranceSlabSaga from './containers/insurance-slab-container/saga/insuranceSlabSaga';


export default function* sagas() {
    yield all([
        ...CitySaga,
        ...StateSaga,
        ...RemarkSaga,
        ...ProductSaga,
        ...CustomerSaga,
        ...FileSaga,
        ...CompanySaga,
        ...UserSaga,
        ...AuthSaga,
        ...AppSaga,
        ...PermissionsMasterSaga,
        ...RolePermissionsSaga,
        ...AreaSaga,
        ...CatalogueSaga,
        ...CommissionSaga,
        ...CaseSaga,
        ...ExcelSaga,
        ...CrossSaleSaga,
        ...MastersSaga,
        ...TargetSaga,
        ...WalletSaga,
        ...InsuranceSlabSaga
    ]);
}
